import React from 'react';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '@headlessui/react';
import '../../utils/constants.esm.js';
import { CardBody } from '../Card/CardBody.esm.js';
import { CardFooter } from '../Card/CardFooter.esm.js';

function DatePickerLayout({ actions, calendar, dataMetrics, dataTestId, inputs, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(CardBody, { dataMetrics: dataMetrics, dataTestId: dataTestId, addClassName: "tw-flex tw-flex-col tw-space-y-2" },
            React.createElement("div", null, inputs),
            calendar),
        React.createElement(CardFooter, null, actions)));
}

export { DatePickerLayout };
//# sourceMappingURL=DatePickerLayout.esm.js.map
